import React from "react";

const DragMiniCard = ({ children, style }) => {
  return (
    <div style={{ ...style }} className="dragminCard">
      {children}
    </div>
  );
};

export default DragMiniCard;
